// Dizzplace - pasek informacyjny nad naglowkiem.
//
// Wiadomosci sa blokami sekcji. Na komputerze widac jedna naraz i skrypt
// podmienia je w kolko; na telefonie pasek jedzie tasma z CSS, wiec skrypt
// nie ma tam nic do roboty. Bez skryptu zostaje pierwsza wiadomosc - pasek
// dziala dalej, tylko sie nie zmienia.

(() => {
  const PROG_DESKTOP = 990;

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.wiadomosci = Array.from(this.querySelectorAll('[data-wiadomosc]'));
      /* Punktem wyjscia jest ta wiadomosc, ktora naprawde stoi na pasku -
         przy przerysowaniu sekcji w edytorze motywu nie musi to byc pierwsza. */
      this.biezaca = Math.max(0, this.wiadomosci.findIndex((el) => !el.hidden));
      this.zegar = null;

      const zadana = Number.parseInt(this.dataset.rotacja, 10);
      this.odstep = Number.isFinite(zadana) && zadana >= 1000 ? zadana : 5000;

      if (this.wiadomosci.length < 2) return;

      this.media = window.matchMedia(`(min-width: ${PROG_DESKTOP}px)`);
      this.media.addEventListener('change', () => this.przelicz());

      /* Pasek za plecami klienta nie ma po co chodzic. */
      document.addEventListener('visibilitychange', () => this.przelicz());

      this.przelicz();
    }

    disconnectedCallback() {
      this.stop();
    }

    przelicz() {
      if (this.media.matches && !document.hidden) this.start();
      else this.stop();
    }

    start() {
      if (this.zegar) return;
      this.ustawWidoczna();
      this.zegar = window.setInterval(() => this.nastepna(), this.odstep);
    }

    /* Na pasku ma stac dokladnie jedna wiadomosc. Po powrocie na karte albo po
       przerwanym przejsciu moze ich byc zero albo dwie - wtedy zostaje biezaca. */
    ustawWidoczna() {
      this.wiadomosci.forEach((element, indeks) => {
        this.posprzataj(element);
        element.hidden = indeks !== this.biezaca;
      });
    }

    stop() {
      if (!this.zegar) return;
      window.clearInterval(this.zegar);
      this.zegar = null;
    }

    /* Poprzednia wiadomosc wyjezdza w lewo, nastepna wjezdza z prawej. Obie sa
       widoczne przez te pol sekundy - wyjezdzajaca na warstwie, zeby nie
       rozpychala paska. Klasy sa zdejmowane i zakladane na nowo, inaczej ta
       sama animacja nie odpali drugi raz. */
    nastepna() {
      const poprzednia = this.wiadomosci[this.biezaca];
      this.biezaca = (this.biezaca + 1) % this.wiadomosci.length;
      const kolejna = this.wiadomosci[this.biezaca];

      this.posprzataj(poprzednia);
      this.posprzataj(kolejna);

      kolejna.hidden = false;
      void kolejna.offsetWidth;
      poprzednia.classList.add('topbar__msg--wychodzi');
      kolejna.classList.add('topbar__msg--wchodzi');

      this.poAnimacji(poprzednia, () => {
        /* Warunek jest tu istotny: w karcie schowanej w tle przegladarka
           przytrzymuje timery, wiec zapasowe wywolanie z POPRZEDNIEGO przejscia
           potrafi przyjsc juz po nastepnym - i ukrylo by wiadomosc, ktora
           wlasnie weszla. Chowamy tylko te, ktora nadal wyjezdza. */
        if (!poprzednia.classList.contains('topbar__msg--wychodzi')) return;
        poprzednia.classList.remove('topbar__msg--wychodzi');
        poprzednia.hidden = true;
      });
      this.poAnimacji(kolejna, () => kolejna.classList.remove('topbar__msg--wchodzi'));
    }

    /* Wiadomosc, ktora nie doczekala konca swojej animacji (np. karta wrocila
       na wierzch w polowie przejscia), musi wrocic do stanu wyjsciowego. */
    posprzataj(element) {
      element.classList.remove('topbar__msg--wychodzi', 'topbar__msg--wchodzi');
    }

    poAnimacji(element, dalej) {
      let zrobione = false;
      const koniec = () => {
        if (zrobione) return;
        zrobione = true;
        dalej();
      };
      element.addEventListener('animationend', koniec, { once: true });
      /* Zapas na wypadek wylaczonych animacji - bez niego wyjezdzajaca
         wiadomosc zostalaby na ekranie na zawsze. */
      window.setTimeout(koniec, 700);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }
})();
